<template>
  <div class="main-container container-xxl">
    <titulo-grande :texto="titulo" posicao="left" />

    <div class="alert alert-success text-success text-center" role="alert">
      <span v-html="texto"></span>
      <router-link class="btn btn-lg btn-primary mt-5" to="/cursos">Clique aqui para fazer o curso.</router-link>
    </div>
  </div>
</template>

<script>
import TituloGrande from '@/components/TituloGrande.vue'
export default {
  components: { TituloGrande },
  name: 'Temporaria',
  props: {
    titulo: {
      default: 'Sem acesso'
    },
    texto: {
      default: ''
    }
  }
}
</script>